(() => {
  const overlay = document.querySelector('[data-svideo-overlay]');
  if (!overlay) return;

  const benefitsRoot = overlay.querySelector('[data-svideo-benefits]');
  const benefitItems = benefitsRoot
    ? [...benefitsRoot.querySelectorAll('.svideo__cta-benefit-motion')]
    : [];
  const flavorSlides = [...overlay.querySelectorAll('[data-svideo-flavor-slide]')];
  const caffeineCallout = overlay.querySelector('[data-svideo-caffeine]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const isMobile = window.matchMedia('(max-width: 749px)');

  const FLAVOR_INTERVAL = Math.max(2, Number(overlay.dataset.svideoFlavorInterval) || 4) * 1000;
  const MOUSE_EASE = 0.09;
  const MOUSE_RANGE_X = 32;
  const MOUSE_RANGE_Y = 22;
  const CAFFEINE_FILE_RE = /pinaColada|candyCluster/i;

  let targetMX = 0;
  let targetMY = 0;
  let currentMX = 0;
  let currentMY = 0;
  let motionRaf = null;
  let flavorIndex = 0;
  let flavorTimer = null;
  let interactive = false;

  function isInteractive() {
    return overlay.classList.contains('is-interactive');
  }

  function slideHasCaffeine(slide) {
    if (!slide) return false;
    if (slide.dataset.caffeine === 'true') return true;
    if (slide.dataset.caffeine === 'false') return false;
    const file = slide.dataset.animationFile || '';
    if (CAFFEINE_FILE_RE.test(file)) return true;
    const src = slide.querySelector('model-viewer')?.getAttribute('src') || '';
    return CAFFEINE_FILE_RE.test(src);
  }

  function setAccent(color) {
    if (!color) return;
    overlay.style.setProperty('--svideo-accent', color);
  }

  function setCaffeineCallout(hasCaffeine) {
    if (!caffeineCallout) return;
    caffeineCallout.classList.remove('is-caffeine-on', 'is-caffeine-off');
    caffeineCallout.classList.add(hasCaffeine ? 'is-caffeine-on' : 'is-caffeine-off');
    caffeineCallout.setAttribute('aria-hidden', hasCaffeine ? 'false' : 'true');
  }

  function showFlavor(index) {
    if (!flavorSlides.length) return;
    flavorIndex = ((index % flavorSlides.length) + flavorSlides.length) % flavorSlides.length;

    flavorSlides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === flavorIndex);
    });

    const active = flavorSlides[flavorIndex];
    setAccent(active?.dataset.accent);
    setCaffeineCallout(slideHasCaffeine(active));
  }

  function startFlavorLoop() {
    if (flavorSlides.length <= 1 || reduceMotion.matches || isMobile.matches) return;
    stopFlavorLoop();
    flavorTimer = window.setInterval(() => {
      if (!isInteractive()) return;
      showFlavor(flavorIndex + 1);
    }, FLAVOR_INTERVAL);
  }

  function stopFlavorLoop() {
    if (flavorTimer) {
      clearInterval(flavorTimer);
      flavorTimer = null;
    }
  }

  function motionEnabled() {
    return interactive && !reduceMotion.matches && !isMobile.matches;
  }

  function benefitMotion(time) {
    if (!motionEnabled()) {
      motionRaf = null;
      return;
    }

    currentMX += (targetMX - currentMX) * MOUSE_EASE;
    currentMY += (targetMY - currentMY) * MOUSE_EASE;

    benefitItems.forEach((el, i) => {
      const caffeineBenefit = el.closest('[data-svideo-caffeine]');
      if (caffeineBenefit?.classList.contains('is-caffeine-off')) {
        el.style.transform = '';
        return;
      }

      const depth = 0.65 + i * 0.14;
      const phase = i * 1.35;
      const bobX = Math.sin(time * 0.00085 + phase) * 5;
      const bobY = Math.cos(time * 0.001 + phase * 0.9) * 7;
      const x = currentMX * MOUSE_RANGE_X * depth + bobX;
      const y = currentMY * MOUSE_RANGE_Y * depth + bobY;
      el.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0)`;
    });

    motionRaf = requestAnimationFrame(benefitMotion);
  }

  function startMotion() {
    if (motionRaf || !motionEnabled()) return;
    motionRaf = requestAnimationFrame(benefitMotion);
  }

  function stopMotion() {
    if (motionRaf) {
      cancelAnimationFrame(motionRaf);
      motionRaf = null;
    }
    benefitItems.forEach((el) => {
      el.style.transform = '';
    });
    targetMX = 0;
    targetMY = 0;
    currentMX = 0;
    currentMY = 0;
  }

  function onPointerMove(e) {
    if (!motionEnabled()) return;
    const rect = overlay.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    targetMX = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
    targetMY = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
  }

  function onPointerLeave() {
    targetMX = 0;
    targetMY = 0;
  }

  function setInteractive(next) {
    if (next === interactive) return;
    interactive = next;

    if (interactive) {
      showFlavor(flavorIndex);
      if (!isMobile.matches) startFlavorLoop();
      startMotion();
      return;
    }

    stopFlavorLoop();
    stopMotion();
  }

  function syncInteractive() {
    setInteractive(isInteractive());
  }

  showFlavor(0);

  overlay.addEventListener('pointermove', onPointerMove, { passive: true });
  overlay.addEventListener('pointerleave', onPointerLeave, { passive: true });

  const observer = new MutationObserver(syncInteractive);
  observer.observe(overlay, { attributes: true, attributeFilter: ['class'] });

  reduceMotion.addEventListener('change', () => {
    if (!motionEnabled()) {
      stopMotion();
    } else if (interactive) {
      startMotion();
    }
    if (reduceMotion.matches || isMobile.matches) {
      stopFlavorLoop();
    } else if (interactive) {
      startFlavorLoop();
    }
  });

  isMobile.addEventListener('change', () => {
    if (isMobile.matches) {
      stopMotion();
      stopFlavorLoop();
      showFlavor(0);
    } else if (interactive) {
      if (!reduceMotion.matches) startFlavorLoop();
      startMotion();
    }
  });

  syncInteractive();
})();
